import { safeDefine } from "../../registration/safe-define.js";
import { GestureElement } from "../../ui/gesture/element.js";
//#region src/define/ui/gesture.ts
safeDefine(GestureElement);
//#endregion
